import { render, staticRenderFns } from "./mjywlSet.vue?vue&type=template&id=c31c2ba4&scoped=true&"
import script from "./mjywlSet.vue?vue&type=script&lang=js&"
export * from "./mjywlSet.vue?vue&type=script&lang=js&"
import style0 from "./mjywlSet.vue?vue&type=style&index=0&id=c31c2ba4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31c2ba4",
  null
  
)

export default component.exports